import { NodeViewWrapper, type ReactNodeViewProps } from '@tiptap/react';
import React, { forwardRef } from 'react';

import { Box } from '@vimeo/bokeh';

import { TIMESTAMP_BADGE_COLOR_STYLES, TIMESTAMP_BADGE_LAYOUT_PROPS } from '../../../constants';

const TimestampNodeView = ({ node: { attrs } }: ReactNodeViewProps) => {
  const { value, hidden, newStyleUI } = attrs as {
    value: string;
    hidden: boolean;
    newStyleUI: boolean;
  };

  if (hidden || !value) {
    return <NodeViewWrapper style={{ display: 'none' }} />;
  }

  return (
    <NodeViewWrapper
      as="span"
      style={{ display: 'inline-block', userSelect: 'none', pointerEvents: 'none' }}
    >
      <FormInputTimecode newStyleUI={newStyleUI}>{value}</FormInputTimecode>
    </NodeViewWrapper>
  );
};

const FormInputTimecode = forwardRef<
  HTMLSpanElement,
  { children: React.ReactNode; newStyleUI: boolean }
>(({ children, newStyleUI }, ref) => {
  return (
    <Box
      as="span"
      fontWeight="bold"
      lineHeight="1.6"
      ref={ref}
      paddingInlineEnd={newStyleUI ? '4px' : undefined}
      _after={
        !newStyleUI
          ? {
              content: "'-'",
              display: 'inline-block',
              fontWeight: 'normal',
              padding: '0 2px',
            }
          : undefined
      }
    >
      {newStyleUI ? (
        <Box as="span" {...TIMESTAMP_BADGE_LAYOUT_PROPS} sx={TIMESTAMP_BADGE_COLOR_STYLES}>
          {children}
        </Box>
      ) : (
        children
      )}
    </Box>
  );
});

FormInputTimecode.displayName = 'FormInputTimecode';

export default TimestampNodeView;
